import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { ReservationListState } from '../../../components/organisms/home/states/ReservationListState';
import { SessionListState } from '../../../components/organisms/sessions/states/SessionListState';
import { LocationApis } from '../../../apis/locations';
import { SheLocation } from '../../../types/location';
import { SubmitState } from '../../../../commonv3/states/SubmitState';

export class CoachingPageState {
  locations: RemoteResourceV3<SheLocation[]> = RemoteResourceV3.loading();
  reservationList: ReservationListState = new ReservationListState();
  sessionList: SessionListState = new SessionListState();
  initState = new SubmitState();

  async init() {
    const { currentUser } = GlobalStatesV3;
    await this.initState.operate(async () => {
      await Promise.all([
        this.reloadLocations(),
        currentUser.reloadUser(),
        this.reservationList.init(),
        this.sessionList.init(),
      ]);
    });
  }
  get loading() {
    return this.initState.submitting;
  }

  async reloadLocations() {
    await updateRemoteResourceV3(
      this.locations,
      (v) => (this.locations = v),
      () => LocationApis.findAll()
    );
  }

  async closeCoachingTooltip() {
    await GlobalStatesV3.currentUser.preference.update({
      coaching_tooltip_closed: true,
    });
  }
}
